enum ExportStatus {
  PENDING,
  RUNNING,
  COMPLETED
}

export interface ExportFile {
  url: string;
  createdAt: string;
}

export interface Export {
  status: ExportStatus;
  createdAt: string;
  exportFiles: ExportFile[];
}

export interface DataError {
  errorType: string;
  message?: string;
}
